import { SVGProps } from "react";
const TickIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g filter="url(#filter0_dd_3169_4960)">
			<path
				d="M5.75 12.8665L8.33995 16.4138C9.15171 17.5256 10.8179 17.504 11.6006 16.3715L18.25 6.75"
				stroke="white"
				strokeWidth={3}
				strokeLinecap="round"
				strokeLinejoin="round"
				shapeRendering="crispEdges"
			/>
		</g>
		<defs>
			<filter
				id="filter0_dd_3169_4960"
				x={4.25}
				y={5.25}
				width={15.5}
				height={15.4844}
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB">
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy={1} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_4960" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy={2} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_3169_4960" result="effect2_dropShadow_3169_4960" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3169_4960" result="shape" />
			</filter>
		</defs>
	</svg>
);
export default TickIcon;

